module.exports = __webpack_public_path__ + "static/img/kaishihuiyi2.f110cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/kaishihuiyi2.png
// module id = 6Rjj
// module chunks = 24